import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { IInsuranceV2 } from 'interfaces/insurance';
import { InterAppLink } from 'components/InterAppLink';
import { localizeDate } from '@pec/aion-ui-i18next/helpers/localize';
import { Message } from '@pec/aion-ui-components/components/Message';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type RouteParams = {
  organizationId: string;
};

type Props = {
  insuranceExpiring: IInsuranceV2[];
};

export const InsuranceExpiringV2: React.FC<Props> = ({ insuranceExpiring }) => {
  const { t } = useTranslation();
  const { organizationId } = useParams<RouteParams>();

  return (
    <Grid item xs={12}>
      <Message
        primaryText={t('subscriber:dashboard.insuranceExpiring.title', 'Your Insurance is Expiring Soon')}
        variant="warning"
      >
        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
          {insuranceExpiring.map(({ organizationName, questionSectionId, earliestPolicyExpirationDateUtc }, i) => (
            <li key={i}>
              <Typography variant="body1">
                <InterAppLink
                  url={`/organizations/${organizationId}/questionnaire-v2/${questionSectionId}`}
                  displayText={t('subscriber:dashboard.insuranceExpiring.expiredDate', {
                    organizationName,
                    date: localizeDate(earliestPolicyExpirationDateUtc, t),
                    defaultValue: '{{organizationName}} expires on {{date}}'
                  })}
                />
              </Typography>
            </li>
          ))}
        </ul>
        <Typography variant="subtitle1">
          {t(
            'subscriber:dashboard.insuranceExpiring.subtitle',
            'Please follow the links above to upload new insurance documents.'
          )}
        </Typography>
      </Message>
    </Grid>
  );
};
